/* eslint-disable no-undef */
import React from "react";
import { useSearchParams } from "react-router";
import AdminAppShell from "./AdminAppShell";
import Authorization from "./Authorization";
import ManageCustomers from "./ManageCustomers/ManageCustomers";
import ManageUsers from "./ManageUsers/ManageUsers";
import ManageQueue from "./ManageQueue/ManageQueue";
const VALID_PAGES = ["authorization", "user", "help", "manageCustomers", "manageUsers", "manageQueue"];
const DEFAULT_PAGE = "authorization";

export function AdminPortal() {
    const [searchParams, setSearchParams] = useSearchParams();

    const pageParam = searchParams.get("page") || DEFAULT_PAGE;
    const page = VALID_PAGES.includes(pageParam) ? pageParam : DEFAULT_PAGE;

    React.useEffect(() => {
        if (pageParam !== page) {
            const next = new URLSearchParams(searchParams);
            next.set("page", page);
            setSearchParams(next, { replace: true });
        }
    }, [pageParam, page]);


    const onNavigate = (next) => {
        if (!VALID_PAGES.includes(next)) return;
        if (next === page && searchParams.toString() === `page=${page}`) return;

        const sp = new URLSearchParams();
        sp.set("page", next);
        setSearchParams(sp);
    };


    const renderPage = () => {
        switch (page) {
            case "authorization":
                return <Authorization />;
            case "manageCustomers":
                return <ManageCustomers />;
            case "manageUsers":
                return <ManageUsers />;
            case "manageQueue":
                return <ManageQueue />;
            case "user":
                return <div style={{ padding: 24 }}>User Profile (coming soon)</div>;
            case "help":
                return <div style={{ padding: 24 }}>Help (coming soon)</div>;
            default:
                return <div>default</div>;
        }
    };

    return (
        <AdminAppShell page={page} onNavigate={onNavigate}>
            {renderPage()}
        </AdminAppShell>
    );
}
